import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Session } from './_types';

interface FetchSessionOptions {
  authToken?: string;
}

export const fetchSession = async (
  baseUrl: string,
  options: FetchSessionOptions = {}
): Promise<Session> => {
  const { authToken } = options;
  const response = await api.get(`${baseUrl}/api/v5/platforms/current`, {
    withCredentials: true,
    params: {
      ...(authToken
        ? { auth_token: authToken, request_from_app: true }
        : {}),
    },
  });
  const camelcased = camelcaseKeys(response.data, { deep: true }) as Session;
  return camelcased;
};
